// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".social-btn-group[data-v-1702c5f4]{margin-top:20px}.social-btn-group .btn[data-v-1702c5f4]{margin-bottom:1.5rem}.social-btn-group .btn i[data-v-1702c5f4]{float:left;font-size:23px}.social-btn-group .btn i.fa-facebook[data-v-1702c5f4]{color:#3f51b5}.social-btn-group .btn i.fa-google[data-v-1702c5f4]{color:#f44336}.h3[data-v-1702c5f4]{margin-bottom:2rem}.resend-link.disabled[data-v-1702c5f4]{pointer-events:none;opacity:.5}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
